import React from 'react';
import { ArrowDownIcon } from "@heroicons/react/solid";
//Allowing <strong>people</strong>, who are not professional developers, to create, configure, extend and finally <strong>program</strong> interactive systems, makes it possible to design

const About = () => (
  <section id="about" className="min-h-screen bg-cover bg-fixed bg-right md:bg-hero-pattern bg-black">
    <div className="lg:w-1024 md:w-full mx-auto flex px-8 py-8 md:flex-row flex-col">
      <div className="md:w-1/2 flex flex-col items-start text-left mb-16 text-lg md:text-xl tracking-widest">

        <p className="text-white mb-8 leading-relaxed ">
          Associate Professor at the Department of Computer Science at Universidad Carlos III de Madrid (UC3M), Spain.
        </p>
        <img className="visible md:hidden mb-8 w-fit" src="./assets/images/intro.jpg" alt="Andrea Bellucci"></img>
        <p className="text-white mb-8 leading-relaxed">
          My research in the area of Human-Computer Interaction focuses on the End-User Development paradigm.
          I aim to design interactive systems that address the <strong>goals</strong>, <strong>interests</strong> and <strong>needs</strong> of people within their own cultural context, from their experience,
          skills and (diverse) <strong>physical</strong> and <strong>cognitive</strong> habilities.
        </p>
        <img className="visible mb-8 w-fit" src="./assets/images/intro2.jpg" alt="Andrea Bellucci"></img>
        <p className="text-white  mb-8 leading-relaxed">
          I have co-designed with, for and by diverse end users, from toolkits for physical computing with <strong>interaction designers</strong>, to tangible toolkits for the smart home with <strong>families</strong> in Finland and Spain,
          to low-cost interactive assistive devices for <strong>children with disabilities</strong> in underserviced areas in Cochabamba, Bolivia.
        </p>
        <img className="visible mb-8 w-fit" src="./assets/images/intro3.png" alt="Andrea Bellucci"></img>
        <p className="text-white mb-8 leading-relaxed">
          My current research explores embodied interactions for the creation and adaptation of <strong>eXtended Reality</strong> (XR) experiences without the need to “write code”,
          allowing people to configure, tailor, and program XR technology in the same environment where they live and act,
          in a more natural way and according to their needs and circumstances.
        </p>
        <div className="flex justify-center">
          <a
            href="#contact"
            className="inline-flex text-black bg-white border border-white py-2 px-6 focus:outline-none hover:bg-gray-500 hover:text-gray-100 rounded text-base">
            Contact me
          </a>
          <a
            href="#projects"
            className="ml-4 inline-flex text-white border py-2 px-6 focus:outline-none hover:bg-gray-500 hover:text-gray-100 rounded text-base">
            Projects
            <ArrowDownIcon className="w-4 h-4 ml-1 mt-1" />

          </a>
        </div>
      </div>
    </div>
  </section>
);

About.propTypes = {};

About.defaultProps = {};

export default About;
